/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид для каталога товаров
   */
  app.CatalogView = app.ItemsView.extend({
    itemEl: '.tile',
    run: function () {
      if ($('.catalog-filter').length) {
        app.gridHeaderView = new app.GridHeaderView({el: $('.catalog-filter')});
        app.gridHeaderView.on('checkboxes-add', this.checkAll, this);
        app.gridHeaderView.on('checkboxes-remove', this.uncheckAll, this);
        app.gridHeaderView.on('add-checked-in-wish', this.addCheckedInWish, this);
        app.gridHeaderView.on('remove-checked', this.removeCheckedFromCart, this);

        for (var i in this.itemViews) {
          if (this.itemViews.hasOwnProperty(i)) {
            this.itemViews[i].on('update-grid-buttons', app.gridHeaderView.updateButtons, app.gridHeaderView);
          }
        }
        if (this.$('input:checked').length > 1) {
          app.gridHeaderView.updateButtons(true);
        }
      }
      $('.sl-hide').hide();
      this.seoTextInitialize();
      this.listenTo(app.mainWindow, 'window.resize', this.seoTextInitialize);
    },

    /**
     * Установка высоты блоку с сео-текстом.
     */
    seoTextInitialize: function () {
      var slDescriptionTextHeight = $('.sl-description-text').outerHeight();
      $('.seo-text-category').height(slDescriptionTextHeight);
    },

    /**
     * Тыкает на все чекбоксы в списке товаров на странице.
     * Для товара с признаком is_protected не позволяем его отмечать.
     */
    checkAll: function () {
      for (var i in this.itemViews) {
        if (!this.itemViews[i].$el.find('.protected-item').length) {
          this.itemViews[i].activate();
        }
      }
    },

    /**
     * Снимает все чекбоксы в списке товаров на странице.
     */
    uncheckAll: function () {
      for (var i in this.itemViews) {
        if (this.itemViews.hasOwnProperty(i)) {
          this.itemViews[i].deactivate();
        }
      }
    },

    /**
     * Добавляет все отмеченные товары в избранное.
     */
    addCheckedInWish: function () {
      for (var i in this.itemViews) {
        if (app.wish.get(this.itemViews[i].wtfId) === undefined && this.itemViews[i].checkbox.prop('checked')) {
          this.itemViews[i].toggleInFavorites();
        }
      }
    },

    /**
     * Удаляет все отмеченные товары из корзины.
     */
    removeCheckedFromCart: function () {
      for (var i in this.itemViews) {
        if (this.itemViews[i].checkbox.prop('checked')) {
          this.itemViews[i].qtyView.removeFromCart();
        }
      }

      // информируем GTM об удалении списка товаров из корзины
      app.recommendationsEvents.trigger('deleteItemsListFromCart');
    },
  });
})(jQuery);

}.call(window));